var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.templateFetching)?_c('div',{staticClass:"rightzone_table"},[(_vm.templatesSearching)?_c('LoaderBlock'):_c('div',{staticClass:"cwrap marginbottom--standart"},[_c('div',{staticClass:"cblock_bigtext"},[_vm._v(" "+_vm._s(_vm.$t('TemplatesList:NoTemplates1'))+" ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }